webpackJsonp([245212242617750],{

/***/ 399:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var icon1 = "https://www.winpeforum.com/assets/elements/SapnaGoyal.png";
	var icon2 = "https://www.winpeforum.com/assets/elements/AnjaliMahajan.png";
	var icon3 = "https://www.winpeforum.com/assets/elements/JuhiVasanwala.png";
	var icon4 = "https://www.winpeforum.com/assets/elements/MalaveekaChakravarthy.png";
	var icon5 = "https://www.winpeforum.com/assets/elements/Ankita.png";
	var icon6 = "https://www.winpeforum.com/assets/elements/MitaSood.png";
	var icon7 = "https://www.winpeforum.com/assets/elements/AradhanaParikh.png";
	var icon8 = "https://www.winpeforum.com/assets/elements/NehalAgarwal.png";
	var icon9 = "https://www.winpeforum.com/assets/elements/KrunaliShah.png";
	var icon10 = "https://www.winpeforum.com/assets/elements/KratiSankhlecha.png";
	var icon11 = "https://www.winpeforum.com/assets/elements/HemangiDesai.png";
	var icon12 = "https://www.winpeforum.com/assets/elements/SanchaliHoare.png";
	var mentConstant5 = [{
	  imgUrl: icon2,
	  desc: "Anjali is an Investment Professional at Lighthouse Funds, where she has spent three years in Consumer investing. Before this, she spent four years in Investment Banking at Axis Capital. There, she advised mid-market Indian corporations on their fund-raise endeavours across the focus sectors of Chemicals, Pharma and Lifesciences, Logistics and Manufacturing.\n<br/><Br/>\nEarly in her career, after graduation, she also spent two years in core product design at a global engineering firm\u2019s R&D center. That experience played a significant role in shaping her long-term career direction\u2014it clarified her interest in the business side of decision-making, and eventually led to the transition into finance. Private Equity felt like a natural extension of this journey, allowing deeper involvement in value creation alongside portfolio companies.\n <br/><Br/>\nAnjali earned her Bachelor of Technology in Electrical Engineering from NIT Allahabad and MBA from Indian Institute of Management, Kozhikode.\n\n         ",
	  name: "Anjali Mahajan",
	  company: "Lighthouse Funds",
	  post: "Associate Vice President",
	  oldpost: " -",
	  oldcompany: "-",
	  linkedIn: "https://www.linkedin.com/in/anjalim21/"
	}, {
	  imgUrl: icon5,
	  desc: "A management consultant with over five years of experience delivering complex, high-impact strategy engagements across smart cities, telecom, technology, retail and healthcare sectors. An accomplished, results-driven MBA with an engineering background, she brings strong capabilities in advanced analytics, structured decision-making and leadership.\n<Br/><Br/>\nHer experience spans India, South-East Asia and the United States, with functional expertise in business strategy, financial and valuation modelling, market entry strategy, supply chain transformation, operating model design, due diligence and predictive modelling.\n\n\n\n         ",
	  name: "Ankita Balotia",
	  company: "Fireside Ventures",
	  post: "Vice President",
	  newpost: "-",
	  newcompany: "-",
	  linkedIn: "https://www.linkedin.com/in/ankita-balotia1792/?original_referer=https%3A%2F%2Fwww%2Egoogle%2Ecom%2F&originalSubdomain=in"
	}, {
	  imgUrl: icon7,
	  desc: "Aradhana Parikh is a Senior Associate at ChrysCapital, where she contributes to private equity investment execution and portfolio support across key sectors. She brings prior experience as an Investment Associate with Hellman & Friedman and as a consultant at Boston Consulting Group, combining analytical rigour with commercial insight.\n<br/><br/>\nAradhana holds an MBA from The Wharton School, University of Pennsylvania, and a Bachelor\u2019s degree in Biology and Economics from the University of Chicago, grounding her investment approach in strong academic foundations and cross-disciplinary perspectives\n\n\n         ",
	  name: "Aradhana Parikh",
	  company: "Chrys Capital",
	  post: "Senior Associate",
	  oldpost: "Partner",
	  oldcompany: "AZB & Partners",
	  linkedIn: "https://www.linkedin.com/in/aradhana-parikh-249187b3/"
	}, {
	  imgUrl: icon11,
	  desc: " \n\n         ",
	  name: "Hemangi Desai",
	  company: "Trifecta Capital",
	  post: "Associate Director, Credit ",
	  oldpost: "Senior Associate",
	  oldcompany: "CPP Investments",
	  linkedIn: "https://www.linkedin.com/in/hemangi-desai-03065921/"
	}, {
	  imgUrl: icon3,
	  desc: " \n\n         ",
	  name: "Juhi Vasanwala",
	  post: "Investment Manager",
	  company: "British International Investment",
	  oldpost: "Executive Director",
	  oldcompany: "Eversource Capital",
	  linkedIn: "https://www.linkedin.com/in/juhi-vasanwala/"
	}, {
	  imgUrl: icon10,
	  desc: " \n\n         ",
	  name: "Krati Sankhlecha",
	  company: "CPPIB",
	  post: "Associate",
	  oldpost: "VP",
	  oldcompany: "Trifecta Capital",
	  linkedIn: "https://www.linkedin.com/in/krati-sankhlecha/"
	}, {
	  imgUrl: icon9,
	  desc: "Krunali Shah has been an Investor with A91 Partners for 5 years. She is involved with investments across consumer brands, financial services and technology. Prior to joining A91, Krunali was a part of the Boston Consulting Group. She has graduated from IIM Ahmedabad and is a Chartered Accountant. \n\n\n         ",
	  name: "Krunali Shah",
	  company: "A91 Partners",
	  post: "Investor",
	  oldpost: "AVP - Compliance",
	  oldcompany: "Lighthouse Funds",
	  linkedIn: "https://www.linkedin.com/in/krunali-shah-pinjani/"
	}, {
	  imgUrl: icon4,
	  desc: " \n         ",
	  name: "Malaveeka Chakravarthy",
	  company: "AZB & Partners",
	  post: "Partner",
	  oldpost: "Senior Specialist Investment & Portfolio Management  ",
	  oldcompany: "Accion Emerge",
	  linkedIn: "https://www.linkedin.com/in/malaveeka/"
	}, {
	  imgUrl: icon6,
	  desc: "Mita started her career at Bharucha & Partners, and focuses on mergers and acquisitions, general corporate and commercial advisory, and employment matters. Her expertise includes advising clients on domestic and offshore acquisitions, ranging from organic joint ventures to venture capital and private equity investments, as well on\nlitigious investor exits.\n<Br/><Br/>\nMita routinely advises clients on a wide range of employment law matters including drafting employment policies, advising on structuring employment incentives, termination of employment for misconduct, and compliance with employment law.\n\n\n\n\n         ",
	  name: "Mita Sood",
	  company: "Bharucha & Partners ",
	  post: "Counsel",
	  oldpost: "Vice President",
	  oldcompany: "Peak XV",
	  linkedIn: "https://www.linkedin.com/in/mita-sood-44b019bb/"
	}, {
	  imgUrl: icon8,
	  desc: " ",
	
	  name: "Nehal Agarwal",
	  company: "British International Investment",
	  post: "Investment Executive ",
	  oldpost: "Senior Vice President- Investments",
	  oldcompany: "Iron Pillar Fund",
	  linkedIn: "https://www.linkedin.com/in/nehal-agarwal-24103165/"
	}, {
	  imgUrl: icon12,
	  desc: " Sanchali is a private equity professional at Multiples with over 7 years of experience in IB/ PE. During this time, she has been involved in market defining private transactions while having the privilege of partnering with industry pioneers. She enjoys dissecting businesses, understanding risk and partnering in long term value creation. Outside of work you will find her on long leisurely walks, hosting friends at home, working out, travelling or planning her next dive.\n\n\n         ",
	  name: "Sanchali Hoare",
	  company: "Multiples Alternate",
	  post: "Associate Vice President",
	  oldpost: "Senior Associate",
	  oldcompany: "CPP Investments",
	  linkedIn: "https://www.linkedin.com/in/sanchalihoare/"
	}, {
	  imgUrl: icon1,
	  desc: "Sapna Goyal is a seasoned investor with 13+ years of experience in early and growth-stage tech startups in India. At WaterBridge Ventures, she leads early-stage investments in AI and DeepTech. Previously, she led M&A and Strategy at Udaan, where she helped Udaan raise upwards of $800M in capital, looked at new business launches and led various strategic investments. Prior to that, she was a Growth-Stage Investor at Goldman Sachs. Sapna holds an MBA from IIM Kozhikode and a bachelor\u2019s from Lady Shri Ram College. She is passionate about entrepreneurship, technology, and building a more inclusive investment ecosystem.\n         ",
	  name: "Sapna Goyal",
	  company: "WaterBridge Ventures",
	  post: "Vice President",
	  linkedIn: "https://www.linkedin.com/in/sapna-goyal1/"
	},,];
	
	exports.default = mentConstant5;
	module.exports = exports["default"];

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Index = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(573);
	
	var _Modal = __webpack_require__(22);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(19);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contentPage = __webpack_require__(17);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(18);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _mentConstant = __webpack_require__(399);
	
	var _mentConstant2 = _interopRequireDefault(_mentConstant);
	
	var _Media = __webpack_require__(42);
	
	var _MediaRight = __webpack_require__(60);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    { direction: '', className: 'teamdetails__wrapper', show: show, onHide: onHide },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'head_section' },
	        _react2.default.createElement(
	          'span',
	          { className: 'item_name' },
	          activeItem.name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item_des' },
	          activeItem.post
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item_des' },
	          activeItem.company
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'cross pull-right' },
	        _react2.default.createElement('i', { onClick: onHide, className: 'fa fa-times' })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'item__desc force-overflow' },
	        _react2.default.createElement('div', { className: 'item__desc_scr', style: { padding: "0px 10px 0px 0px" }, dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var Index = exports.Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index(args) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      activeItem: {},
	      isShow: false
	    };
	
	    return _this;
	  }
	
	  Index.prototype.render = function render() {
	    var _this2 = this;
	
	    var location = this.props.location;
	    var isShow = this.state.isShow;
	
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, { title: 'Winpe ProClub Mentorship Program | Mentees: Cohort of 2025', description: 'A group of highly talented young women on their path to continued success.', image: "https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg", location: location }),
	      _react2.default.createElement(
	        'div',
	        { className: 'mentees-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'heading' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Mentees ',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('span', null),
	              ' Cohort VI'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section_intro_text' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'A group of highly talented young women on their path to continued success.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _mentConstant2.default.map(function (item, i) {
	              if (i >= 13) return _react2.default.createElement(
	                'div',
	                { className: '  col-sm-12 col-md-12  ' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'circle-card', style: { marginBottom: '200px' } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-inner', onClick: function onClick() {
	                        return _this2.togglePopUp(item);
	                      } },
	                    _react2.default.createElement('img', { onClick: function onClick() {
	                        return _this2.togglePopUp(item);
	                      }, className: 'imagess', style: { width: "200px", height: "200px", objectFit: "cover" }, src: item.imgUrl }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'overlayy' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'cercle' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'text' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'circle-name' },
	                        item.name,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.post,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.company,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'a',
	                        { target: '_blank', href: item.linkedIn, className: 'linkedinbtn btn btn-primary btn-sm' },
	                        _react2.default.createElement('i', { className: 'fa fa-linkedin' })
	                      )
	                    )
	                  )
	                )
	              );else return _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6 col-md-4' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'circle-card', style: { marginBottom: '200px' } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-inner', onClick: function onClick() {
	                        return _this2.togglePopUp(item);
	                      } },
	                    _react2.default.createElement('img', { onClick: function onClick() {
	                        return _this2.togglePopUp(item);
	                      }, className: 'imagess', style: { width: "200px", height: "200px", objectFit: "cover" }, src: item.imgUrl }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'overlayy' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'cercle' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'text' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'circle-name' },
	                        item.name,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.post,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.company,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'a',
	                        { target: '_blank', href: item.linkedIn, className: 'linkedinbtn btn btn-primary btn-sm' },
	                        _react2.default.createElement('i', { className: 'fa fa-linkedin' })
	                      )
	                    )
	                  )
	                ),
	                ' '
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TeamModal, { show: isShow, onHide: this.togglePopUp, activeItem: this.state.activeItem })
	      )
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	Index.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = Index;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cohort-vi-index-js-88e0ef1ad20eba54cab0.js